import React from "react";

function OrgNode({ name, title }: { name: string; title: string }) {
  return (
    <div className="flex flex-col items-center">
      <div className="w-12 h-12 rounded-full bg-[#FBD037]/20 border-2 border-[#FBD037]/60 flex items-center justify-center text-base font-bold text-[#212121] shadow-sm">
        {name.charAt(0)}
      </div>
      <div className="mt-1 text-center">
        <div className="text-[11px] font-semibold text-[#212121] whitespace-nowrap">{name}</div>
        <div className="text-[10px] text-gray-400 whitespace-nowrap">{title}</div>
      </div>
    </div>
  );
}

export default function OrganisationalChart() {
  return (
    <div className="mt-2 w-full bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl rounded-b-3xl rounded-tr-3xl border border-white/20 shadow-sm p-10 overflow-auto animate-in fade-in duration-300" style={{minHeight:520}}>
      <style>{`
        .org-tree { display:flex; justify-content:center; }

        /* Children row — padding-top creates gap below parent node */
        .org-tree ul {
          display: flex;
          padding-top: 30px; 
          position: relative;
          transition: all 0.5s;
          margin: 0; padding-left: 0;
        }

        /* Each item container */
        .org-tree li {
          float: left;
          text-align: center;
          list-style-type: none;
          position: relative;
          padding: 30px 10px 0 10px;
          transition: all 0.5s;
        }

        /* Vertical stem connecting to parent */
        .org-tree li::before, .org-tree li::after {
          content: '';
          position: absolute;
          top: 0;
          right: 50%;
          border-top: 2px solid #E5E7EB; /* gray-200 */
          width: 50%;
          height: 30px;
        }
        .org-tree li::after {
          right: auto;
          left: 50%;
          border-left: 2px solid #E5E7EB;
        }

        /* End nodes cleanups */
        .org-tree li:only-child::after, .org-tree li:only-child::before {
          display: none;
        }
        .org-tree li:only-child {
          padding-top: 0;
        }
        .org-tree li:first-child::before, .org-tree li:last-child::after {
          border: 0 none;
        }
        .org-tree li:last-child::before {
          border-right: 2px solid #E5E7EB;
          border-radius: 0 8px 0 0;
        }
        .org-tree li:first-child::after {
          border-radius: 8px 0 0 0;
        }

        /* Vertical line from parent dropping down to children horizontal line */
        .org-tree ul ul::before {
          content: '';
          position: absolute;
          top: 0;
          left: 50%;
          border-left: 2px solid #E5E7EB;
          width: 0;
          height: 30px;
        }

        .org-tree li > div {
          display: inline-block;
        }
      `}</style>
      <div className="org-tree">
        <ul>
          <li>
            <OrgNode name="John Doe" title="CEO" />
            <ul>
              <li>
                <OrgNode name="Jane Smith" title="CTO" />
                <ul>
                  <li><OrgNode name="Vikram Singh" title="VP Engineering" /></li>
                  <li><OrgNode name="Priya Sharma" title="VP Product" /></li>
                </ul>
              </li>
              <li>
                <OrgNode name="Sushil Rathore" title="CHRO" />
                <ul>
                  <li><OrgNode name="Sneha Joshi" title="HR Director" /></li>
                  <li><OrgNode name="Karan Mehta" title="Talent Head" /></li>
                  <li>
                    <OrgNode name="Anita Desai" title="Comp & Ben" />
                    <ul>
                      <li><OrgNode name="Arjun Kapoor" title="Analyst" /></li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <OrgNode name="Divya Nair" title="CFO" />
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
}
